import { useEffect } from 'react';

const useRequestAnimationFrame = () => {
  useEffect(() => {
    let lastTime = 0;

    for (const vendor of ['ms', 'moz', 'webkit', 'o']) {
      if (typeof window.requestAnimationFrame !== 'function') {
        window.requestAnimationFrame = (window as any)[`${vendor}RequestAnimationFrame`];
      }

      if (typeof window.cancelAnimationFrame !== 'function') {
        window.cancelAnimationFrame =
          (window as any)[`${vendor}CancelAnimationFrame`] ||
          (window as any)[`${vendor}CancelRequestAnimationFrame`];
      }
    }

    if (typeof window.requestAnimationFrame !== 'function') {
      window.requestAnimationFrame = (callback: FrameRequestCallback) => {
        const currTime = new Date().getTime();
        const timeToCall = Math.max(0, 16 - (currTime - lastTime));
        const id = window.setTimeout(() => callback(currTime + timeToCall), timeToCall);

        lastTime = currTime + timeToCall;
        return id;
      };
    }

    if (typeof window.cancelAnimationFrame !== 'function') {
      window.cancelAnimationFrame = clearTimeout;
    }
  }, []);
};

export default useRequestAnimationFrame;
